import axios from "axios";
import {
  CxSecurityGroupDetailsDto,
  MySecurityGroupsResponse,
  SecurityGroupClient,
  SecurityGroupMemberIdsRequest,
  TenantAdminUserDto,
  UserManagementClient,
} from "lib/ShiOneClient";
import { ApiClientConfig } from "../auth/ApiClientConfig";
import { GetAxiosHeaders } from "../auth/GetAxiosHeaders";

const legacyBaseUrl = `${import.meta.env.API_ENDPOINT}/api/Team`;

export const api = new SecurityGroupClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

const userManagementApi = new UserManagementClient(
  ApiClientConfig,
  import.meta.env.API_ENDPOINT
);

export async function getRestEnableTeams(accountId: number): Promise<CxSecurityGroupDetailsDto[]> {
  const axiosHeaders = await GetAxiosHeaders();

  const response = await axios.get<CxSecurityGroupDetailsDto[]>(
    legacyBaseUrl + `/enableteams/${accountId}`,
    { headers: axiosHeaders }
  );

  return response.data;
}

export async function getRestAccountTeams(): Promise<CxSecurityGroupDetailsDto[]> {
  return api.listSecurityGroups();
}

export async function addUsersToTeam(
  teamId: number,
  userIds: string[]
): Promise<CxSecurityGroupDetailsDto> {
  return api.addMembers(teamId, new SecurityGroupMemberIdsRequest({ userIds }));
}

export async function removeUsersFromTeam(
  teamId: number,
  userIds: string[]
): Promise<CxSecurityGroupDetailsDto> {
  return api.removeMembers(teamId, new SecurityGroupMemberIdsRequest({ userIds }));
}

export async function getRestMySecurityGroups(): Promise<MySecurityGroupsResponse> {
  return api.getMySecurityGroups();
}

// Guid-keyed account users (bridges legacy ContactId via .contactId) backed by the new
// CustomerExperienceUser-based UserManagementController, used to resolve security-group
// members since SecurityGroupController identifies members by CustomerExperienceUser UserId,
// not ContactId.
export async function getMappedAccountUsers(): Promise<TenantAdminUserDto[]> {
  return userManagementApi.getMappedUsers();
}
